<template>
    <div class="paymentBox">
        <div class="title">
            <p></p>
            <h4>上传缴费信息</h4>
        </div>
<!--        上传缴费信息-->
        <div class="matter">
            <div class="fileContent">
                <p>上传缴费信息:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="10"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf,.png,.jpg,.zip,.rar"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="paymentList"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--        发票信息-->
        <div class="invoice" v-if="company_id!=0">
            <div class="title" style="margin-bottom: 30px">
                <p></p>
                <h4>发票信息</h4>
            </div>
            <el-form ref="invoiceForm" :rules="rules" :model="invoiceForm" label-width="150px">
                <el-form-item label="发票类型"  prop="fapiao_type" >
                    <el-radio-group v-model="invoiceForm.fapiao_type">
                        <el-radio :label="2">增值税普通发票</el-radio>
                        <el-radio :label="3">增值税专用发票</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <el-form ref="invoiceForm" :model="invoiceForm.fapiao_arr" label-width="150px">
                <el-form-item label="发票抬头" prop="taitou" :rules="[{ required: true, message: '请输入发票抬头' },]">
                    <el-input v-model="invoiceForm.fapiao_arr.taitou" disabled></el-input>
                </el-form-item>
                <el-form-item label="统一信用社会代码" prop="tongyi_ma" :rules="[{ required: true, message: '请输入统一信用社会代码'},]">
                    <el-input v-model="invoiceForm.fapiao_arr.tongyi_ma" disabled></el-input>
                </el-form-item>
                <el-form-item label="发票邮寄地址" prop="youji_dizhi" :rules="[{ required: true, message: '请输入发票邮寄地址' },]">
                    <el-input v-model="invoiceForm.fapiao_arr.youji_dizhi"></el-input>
                </el-form-item>
                <el-form-item label="开户银行名称" prop="kaihu_ming" :rules="[{ required: invoiceForm.fapiao_type==3, message: '请输入开户银行名称' },]">
                    <el-input v-model="invoiceForm.fapiao_arr.kaihu_ming"></el-input>
                </el-form-item>
                <el-form-item label="基本开户账号" prop="kaihu_hao" :rules="[{ required: invoiceForm.fapiao_type==3, message: '请输入基本开户账号' },]">
                    <el-input v-model="invoiceForm.fapiao_arr.kaihu_hao"></el-input>
                </el-form-item>
                <el-form-item label="注册场所地址" prop="zhuce_dizhi" :rules="[{ required: invoiceForm.fapiao_type==3, message: '请输入注册场所地址' },]">
                    <el-input v-model="invoiceForm.fapiao_arr.zhuce_dizhi"></el-input>
                </el-form-item>
                <el-form-item label="注册固定电话" prop="zhuce_dianhua" :rules="[{ required: invoiceForm.fapiao_type==3, message: '请输入注册固定电话' },]">
                    <el-input v-model="invoiceForm.fapiao_arr.zhuce_dianhua"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="preserve">
            <el-button @click="saveBtn">保存</el-button>
            <el-tooltip class="item" effect="dark" content="确认完成上传，等待保险公司上传正式保单保函等资料" placement="top">
                <el-button @click="verifyBtn">确认上传</el-button>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import { completePayment, savePaymentInformation, viewPaymentInformation } from '../../../api/insure';

    export default {
        name: 'uploadPayment',
        data(){
            return{
                invoiceForm:{
                    fapiao_type:'2',
                    fapiao_arr:{
                        taitou:'',
                        tongyi_ma:'',
                        youji_dizhi:'',
                        kaihu_ming:'',
                        kaihu_hao:'',
                        zhuce_dizhi:'',
                        zhuce_dianhua:''
                    }
                },
                company_id:'',
                url:process.env.VUE_APP_BASE_API+'/api/upload_jiaofei_file',
                headers:{
                    "Authorization": sessionStorage.getItem("token")
                },
                rules:{
                    fapiao_type:[
                        { required: true, message: '请选择发票类型' },
                    ]
                },
                upload_data:{
                    case_id:'',
                    doc_type:'79',  //上传缴费信息
                },
                payment_file:[],
                paymentList:[]
            }
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            //删除
            handleRemove(file, fileList){
                let arr = [];
                fileList.forEach(res => {
                    if (!res.response) {
                        arr.push(res.psd_code);
                    } else {
                        arr.push(res.response.data.psd_code);
                    }
                });
                this.payment_file = arr;
            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code==200){
                    if (response.data.doc_type==79){
                        this.payment_file.push(response.data.psd_code)
                    }
                    this.$message.success(response.msg)
                }else {
                    this.$message.error(response.msg)
                }
            },
            //限制上传个数
            handleExceed(files, fileList){
                if (fileList.length>=10){
                    this.$message.error('只能上传10个文件');
                }
            },
            //保存
            saveBtn(){
                //0 表示个人  !0 表示企业
                if (this.company_id==0){
                    savePaymentInformation({case_id:this.$route.query.id,jiaofei_psd_codes:this.payment_file,kaipiao_arr:this.invoiceForm}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }else {
                    //企业身份
                    this.$refs.invoiceForm.validate((valid) => {
                        if (valid) {
                            let data={
                                case_id:this.$route.query.id,
                                jiaofei_psd_codes:this.payment_file,
                                kaipiao_arr:this.invoiceForm
                            }
                            savePaymentInformation(data).then(res=>{
                                if (res.code==200){
                                    this.$message.success(res.msg)
                                }else {
                                    this.$message.error(res.msg)
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }
            },
            //确认上传
            verifyBtn(){
                this.$confirm('请确认缴费信息是否已经完成上传、填写 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    completePayment({case_id:this.$route.query.id}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });

            }
        },
        created() {
            this.upload_data.case_id=this.$route.query.id
            viewPaymentInformation({case_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    this.company_id=res.data.company_id
                    this.invoiceForm=res.data.kaipiao_arr
                    if (res.data.jiaofei_list!=''&&res.data.jiaofei_list!=undefined){
                        res.data.jiaofei_list.map(res=>{
                            this.paymentList.push(res)
                            this.payment_file.push(res.psd_code)
                        })
                    }
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .paymentBox{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
        min-width: 95% !important;
        width: max-content;
    }
    .title{
        display: flex;
        align-items: center;
        color: #3e62f6;
    }
    .title>p{
        width: 5px;
        height: 18px;
        background-color: #3e62f6;
        margin-right: 10px;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 50px 25px;
    }
    .custom{
        background-color: #3f5cf7;
        color: #fff;
    }
    /deep/.el-input__inner{
        color: #878889 !important;
    }
    /deep/.el-form-item__content{
        height: 32px;
        align-items: center;
    }
    /deep/.el-form-item__content{
        display: flex;
    }
    /deep/.el-input--small,
    /deep/.el-input__inner{
        width: 250px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    /deep/.el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .preserve{
        width: 100%;
        text-align: center;
        margin-top: 50px;
    }
    .preserve>button{
        width: 120px;
        background-color: #3b63f6;
        color: #fff;
        height: 40px;
        border-radius: 5px;
    }

    /deep/.el-upload-list{
        display: flex;
        align-items: flex-end;
    }
    .invoice{
        margin: 20px 0px;
    }
</style>
